import React, { FC } from "react";
import { CircularProgress, Flex } from "@evergis/ui";

export const ChartLoading: FC<{ column?: boolean }> = ({ column }) => (
  <div style={{ position: "absolute", width: "100%", height: "inherit" }}>
    <Flex
      center
      style={{
        alignItems: "center",
        width: "100%",
        height: "inherit",
        marginRight: column || column === undefined ? 0 : "-2rem",
      }}
    >
      <CircularProgress diameter={3} />
    </Flex>
  </div>
);
